import { createUseStyles } from 'react-jss';
import { colors } from '@insurancemenu/imenu-components-lib';
import { boxShadows } from '@insurancemenu/imenu-components-lib/dist/utils';

const styles = {
  typeCard: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '1rem',
    backgroundColor: colors.neutral.white,
    cursor: 'pointer',
  },
  selectedTypeCard: {
    extend: 'typeCard', // Basic styles
    color: colors.blue[600],
  },
  iconBlock: {
    // Layout
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '1.2rem 0.5rem',
    height: '9rem',
    width: '100%',
    boxSizing: 'border-box',
    // Style
    border: `0.1rem solid ${colors.neutral[300]}`,
    color: colors.neutral[600],
    boxShadow: boxShadows.dark[4],
    borderRadius: '1rem',
    '& svg': {
      transition: 'width 0.5s ease',
      width: '5rem',
    },
  },
  selectedIconBlock: {
    extend: 'iconBlock', // Basic styles
    border: `0.1rem solid ${colors.blue[600]}`,
    color: colors.neutral.white,
    backgroundColor: colors.blue[600],
    '& svg': {
      width: '5rem',
    },
  },
  cardTitle: {
    fontSize: '1.2rem',
    textTransform: 'uppercase',
    lineHeight: '1.8rem',
    letterSpacing: '0.036rem',
    transition: 'color 0.3s ease',
    margin: '1rem 0 0',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
